module.exports = __webpack_public_path__ + "img/ctrl-hadamard-stub-up-0.097c9ab1.svg";